export default "__VITE_ASSET__CbCzifae__"